// 🔧 social_builder.js
// ✅ Purpose: Orchestrates Social Engine demo content creation
// ✅ Features:
// - Generates draft social posts from Core + selected add-ons
// - Seeds social draft records through repository layer
// - Updates DemoContext with social results
// - Returns standardized Demo Report results
// - Fully block-commented for clarity and future devs

import { generateSocial } from "./social_generator";
import { seedSocial } from "./social_seeder";
import { buildSocialReport } from "./social_report";

export const buildSocial = async ({ demoContext } = {}) => {
  console.log("📣 Social Builder started.");

  const socialPlan = generateSocial({ demoContext });

  const socialResults = await seedSocial({
    demoContext,
    socialPlan,
  });

  demoContext.social = {
    posts: socialResults.posts || [],
  };

  return buildSocialReport({ socialResults });
};